import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import { roleWiseTables } from "../../pages/Dashboard/Old/constants"

interface DashboardState {
  adminDashboardData: Array<any>
  csmDashboardData: Array<any>
  advisorDashboardData: Array<any>
  gaDashboardData: Array<any>
  subHeaderText: string

  // table state
  currentTable: any
  prevTable: any
  selectedCsm: any
  selectedAdvisor: any
  selectedGa: any
  dashboardCrumbs: Array<any>
  currentUser: string | null

  //dahboard tabs data
  overviewData: any
  opportunityData: any
  doctorData: any
  doctorDataAgg: any
  hygienistsData: any
  hygienistsDataAgg: any

  //Graphs data
  overviewGraphData: any
  metricGraphData: any
  topMetricsSelections: any

  //static
  dashboardTabs: any
  selectedDashboardTab: any
}

const initialState: DashboardState = {
  adminDashboardData: [
    {
      csm: "CSM-A",
      advisors: 3,
      groups: 2,
      opportunities: "NA",
    },
  ],
  csmDashboardData: [],
  advisorDashboardData: [],
  gaDashboardData: [],
  subHeaderText: "",
  currentTable: null,
  prevTable: null,
  selectedCsm: null,
  selectedAdvisor: null,
  selectedGa: null,
  dashboardCrumbs: [],
  currentUser: null,

  //dahboard tabs data
  overviewData: [],
  opportunityData: [],
  doctorData: [],
  doctorDataAgg: [],
  hygienistsData: [],
  hygienistsDataAgg: [],

  //Graphs data
  overviewGraphData: [],
  metricGraphData: [],
  topMetricsSelections: [],

  //static
  dashboardTabs: [
    {
      index: 0,
      id: "overview",
      name: "Overview",
    },
    {
      index: 1,
      id: "opportunities",
      name: "Opportunities",
    },
    {
      index: 2,
      id: "doctors",
      name: "Doctors",
    },
    {
      index: 3,
      id: "hygienists",
      name: "Hygienists",
    },
  ],

  selectedDashboardTab: {
    index: 0,
    id: "overview",
    name: "Overview",
  },
}

const dashboardSlice = createSlice({
  name: "dashboard",
  initialState,
  reducers: {
    setAdminDashboardData: (state, action) => {
      state.adminDashboardData = action.payload
    },
    setCsmDashboardData: (state, action) => {
      state.csmDashboardData = action.payload
    },
    setAdvisorDashboardData: (state, action) => {
      state.advisorDashboardData = action.payload
    },
    setGaDashboardData: (state, action) => {
      state.gaDashboardData = action.payload
    },
    setSubHeaderText: (state, action) => {
      state.subHeaderText = action.payload
    },
    setSelectedCsm: (state, action) => {
      state.selectedCsm = action.payload
    },
    setSelectedAdvisor: (state, action) => {
      state.selectedAdvisor = action.payload
    },
    setSelectedGa: (state, action) => {
      state.selectedGa = action.payload
    },
    addDashboardCrumb: (state, action) => {
      state.dashboardCrumbs.push(action.payload)
    },

    setOverviewData: (state, action) => {
      state.overviewData = action.payload
    },
    setOpportunityData: (state, action) => {
      state.opportunityData = action.payload
    },
    setDoctorData: (state, action) => {
      state.doctorData = action.payload
    },
    setDoctorDataAgg: (state, action) => {
      state.doctorDataAgg = action.payload
    },
    setHygienistsData: (state, action) => {
      state.hygienistsData = action.payload
    },
    setHygienistsDataAgg: (state, action) => {
      state.hygienistsDataAgg = action.payload
    },
    setOverviewGraphData: (state, action) => {
      state.overviewGraphData = action.payload
    },
    setMetricGraphData: (state, action) => {
      state.metricGraphData = action.payload
    },

    setTopMetricsSelections: (state, action) => {
      state.topMetricsSelections = action.payload
    },

    removeGroupFromDashboardCrumb: (state) => {
      // const filteredCrumbs = state.dashboardCrumbs.filter((item) => item.type !== action.payload);
      // state.dashboardCrumbs = filteredCrumbs
      state.dashboardCrumbs.pop()
    },
    onlyCsmDashboardCrumb: (state) => {
      state.dashboardCrumbs = [{ ...state.dashboardCrumbs[0] }]
    },
    emptyDashboardCrumb: (state) => {
      state.dashboardCrumbs = []
    },
    setCurrentTable: (state, action) => {
      state.currentTable = action.payload
    },
    setCurrentUser: (state, action) => {
      state.currentUser = action.payload
    },

    //static
    setSelectedDashboardTab: (state, action) => {
      state.selectedDashboardTab = action.payload
    },
  },
})

export default dashboardSlice.reducer
export const {
  setAdminDashboardData,
  setCsmDashboardData,
  setAdvisorDashboardData,
  setGaDashboardData,
  setSubHeaderText,
  setSelectedCsm,
  setSelectedAdvisor,
  setSelectedGa,
  addDashboardCrumb,
  removeGroupFromDashboardCrumb,
  onlyCsmDashboardCrumb,
  emptyDashboardCrumb,
  setCurrentTable,
  setCurrentUser,
  setSelectedDashboardTab,
  setOverviewData,
  setOpportunityData,
  setDoctorData,
  setDoctorDataAgg,
  setHygienistsData,
  setHygienistsDataAgg,
  setOverviewGraphData,
  setMetricGraphData,
  setTopMetricsSelections,
} = dashboardSlice.actions
